module.exports = __webpack_public_path__ + "static/media/nps.3faad1eb.png";